
import {AdminPanelConfig} from '../admin-panel.config';
import {UserModel} from '../models/user.model';
import {CompanyModel} from '../models/company.model';
import {CommandBase} from '@shared/commands/command-base';

export class AddUserCommand extends CommandBase {
  constructor(public User: UserModel) {
    super(AdminPanelConfig.AddUserApi());
  }
}

export class UpdateUserCommand extends CommandBase {
  constructor(public User: UserModel) {
    super(AdminPanelConfig.UpdateUserApi());
  }
}

export class AddDashboardCommand extends CommandBase {
  constructor(public Users: UserModel[]) {
    super(AdminPanelConfig.AddDashboardApi());
  }
}

export class AddSolutionCommand extends CommandBase {
  constructor(public Solutions: any[]) {
    super(AdminPanelConfig.AddSolutionApi());
  }
}

export class UpdateSolutionCommand extends CommandBase {
  constructor(public Solution: any[]) {
    super(AdminPanelConfig.UpdateSolutionApi());
  }
}

export class AddCompanyCommand extends CommandBase {
  constructor(public Company: CompanyModel) {
    super(AdminPanelConfig.AddCompanyApi());
  }
}

export class UpdateCompanyCommand extends CommandBase {
  constructor(public Company: CompanyModel) {
    super(AdminPanelConfig.UpdateCompanyApi());
  }
}

export class SendConfirmationEmailCommand extends CommandBase {
  constructor(public User: any) {
    super(AdminPanelConfig.SendConfirmationEmailApi());
  }
}

export class CloneUserCommand extends CommandBase {
  constructor(public User: any,
              public ClonedUserEmail: string,
              public ClonedUserCompanyId: string) {
    super(AdminPanelConfig.CloneUserApi());
  }
}

export class UpdateUserNoteCommand extends CommandBase {
  constructor(public UserNote: any) {
    super(AdminPanelConfig.UpdateUserNoteApi());
  }
}

export class CreateSupportTicketForUserCommand extends CommandBase {
  constructor(public Title: string,
              public Description: string,
              public FileAttachments: any,
              public UserName: string,
              public UserCompanyId: string,
              public FirstName: string,
              public LastName: string,
              public Email: string,
              public PackageCode: string) {
    super(AdminPanelConfig.CreateSupportTicketForUserApi());
  }
}

export class SendPasswordCommand extends CommandBase {
  constructor(public UserName: boolean,
              public GeneratePassword: boolean,
              public Password: string,
              public PasswordChange: boolean,
              public SendCopyToMe: boolean) {
    super(AdminPanelConfig.SendPasswordApi());
  }
}
